module.exports = __webpack_public_path__ + "static/img/fda78656c6b0486a76aa75ae60828bf.55fc31ef.jpg";